module.exports = "https://static.wagwalking.com/_next/static/images/petresource-dog-grooming-0067104b7fa57da3301542fe8d80f670.svg";